import { ModelEntityType } from '@upright/common/model/input/types';
import { z } from 'zod';

export const groupfolioEntityType = [ModelEntityType.GROUP, ModelEntityType.PORTFOLIO] as const;
export const zGroupfolioEntityType = z.enum(groupfolioEntityType);
export type GroupfolioEntityType = z.infer<typeof zGroupfolioEntityType>;

export function isGroupfolioEntityType(type: unknown): type is GroupfolioEntityType {
  return groupfolioEntityType.includes(type as GroupfolioEntityType);
}
export function parseGroupfolioType(type: unknown) {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  if (!isGroupfolioEntityType(type)) throw Error(`Unexpected groupfolio type ${type}`);
  return type;
}

const zGroupfolioEntityReference = z.object({
  id: z.string(),
  type: zGroupfolioEntityType,
});

export type GroupfolioEntityReference = z.infer<typeof zGroupfolioEntityReference>;

export const zGroupfolioEntityReferenceWithWeightSetIds = zGroupfolioEntityReference.extend({
  weightSetIds: z.array(z.number()),
});

export type GroupfolioEntityReferenceWithWeightSetIds = z.infer<typeof zGroupfolioEntityReferenceWithWeightSetIds>;
